import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
};

export const blogSlice = createSlice({
  name: 'blogSliceName',
  initialState,
  reducers: {
    addBlog: (state, action) => {
      state.data.push(action.payload);
    },
    getBlogs: (state, action) => {
      state.data = action.payload;
    },
    getOneBlog: (state, action) => {
      const blog = state.data.find((b) => b.id === action.payload);
      state.response = blog || null;
    },
    updateBlog: (state, action) => {
      const index = state.data.findIndex((b) => b.id === action.payload.id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    removeBlog: (state, action) => {
      state.data = state.data.filter((b) => b.id !== action.payload);
    },
    searchBlogByTitle: (state, action) => {
      const searchTerm = action.payload.toLowerCase();
      state.response = state.data.filter((b) =>
        b.title.toLowerCase().includes(searchTerm)
      );
    },
    blogSuccess: (state, action) => {
      state.data = action.payload;
    }
  }
});

export const {
  addBlog,
  getBlogs,
  getOneBlog,
  updateBlog,
  removeBlog,
  searchBlogByTitle,
  blogSuccess
} = blogSlice.actions;

export default blogSlice.reducer;
